import React, { Component } from 'react';


import { FormGroup, Label } from 'reactstrap';

import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/fontawesome-free-solid';
import $ from 'jquery';
import './TwoFactorForm.css';

import IntlTelInput from 'react-intl-tel-input';
import '../../../../../node_modules/react-intl-tel-input/dist/libphonenumber.js';
import '../../../../../node_modules/react-intl-tel-input/dist/main.css';



class Phone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: '',
      countryCode: ''
    };

    this.enable2Factor = this.enable2Factor.bind(this);
    this.onPhoneNumberChange = this.onPhoneNumberChange.bind(this);
  }

  enable2Factor(e) {
    e.preventDefault();
    const data = this.state


    $.ajax({
      url: '/api/v1/sendOtp',
      type: 'POST',
      data: JSON.stringify(data),
      success: function (res) {
        this.props.notifySuccess(res.message);
        this.props.toggleForm();
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  onPhoneNumberChange(status, value, countryData, number, id){
    const countryCode = countryData.dialCode;
    this.setState({
      phone: value,
      countryCode
    })
  }


  render() {
    return (
      <Form className="DataFields twoFactorForm" ref={c => { this.phoneForm = c }} onSubmit={this.enable2Factor}>
        <span onClick={this.props.toggleModal} className="twoFactorForm__closeBtn"><FontAwesomeIcon icon={faTimes} /></span>
        <h2 className="formTitle text-center">Enable two-factor Authentication</h2>

        <FormGroup>
          <Label for="phone" className="text-white mr-sm-2">Phone Number</Label>
          {/* <Input type="tel" name="phone" id="phone" className="form-control" /> */}
          <IntlTelInput
            fieldName="phone"
            value={this.state.phone}
            onPhoneNumberChange={this.onPhoneNumberChange}
            preferredCountries={['br']}
            css={['intl-tel-input', 'form-control']}
            utilsScript={'libphonenumber.js'}
          />
        </FormGroup>
        <FormGroup className="text-center">
          <Button type="submit" className="btn btn--submit btn-rounded btn-outline-primary mx-auto">Submit</Button>
        </FormGroup>
      </Form>
    );
  }
}

class OTP extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.confirmOTP = this.confirmOTP.bind(this);
  }


  confirmOTP(e) {
    e.preventDefault();
    const otp = this.otpForm.getValues();

    $.ajax({
      url: '/api/v1/verifyMobileNo',
      type: 'POST',
      data: JSON.stringify(otp),
      success: function (res) {
        this.props.notifySuccess(res.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  render() {
    return (
      <Form className="DataFields twoFactorForm" ref={c => { this.otpForm = c }} onSubmit={this.confirmOTP}>
        <span onClick={this.props.toggleModal} className="twoFactorForm__closeBtn"><FontAwesomeIcon icon={faTimes} /></span>
        <h2 className="formTitle text-center">Please Enter OTP</h2>

        <FormGroup>
          <Label for="otp" className="text-white mr-sm-2">Confirm OTP:</Label>
          <Input type="text" name="otp" id="otp" className="form-control" />
        </FormGroup>
        <FormGroup className="text-center">
          <Button type="submit" className="btn btn--submit btn-rounded btn-outline-primary mx-auto">Submit</Button>
        </FormGroup>
      </Form>
    );
  }
}

class TwoFactorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otpSent: false,
      phone: undefined,
      otp: undefined
    };

    this.toggleForm = this.toggleForm.bind(this);
  }

  toggleForm() {
    this.setState({
      otpSent: !this.state.otpSent
    });
  }

  render() {
    const { otpSent } = this.state;
    if (!otpSent) {
      return <Phone toggleModal={this.props.toggleModal} toggleForm={this.toggleForm} notifySuccess={this.props.notifySuccess} notifyError={this.props.notifyError} />;
    } else {
      return <OTP toggleModal={this.props.toggleModal} toggleForm={this.toggleForm} notifySuccess={this.props.notifySuccess} notifyError={this.props.notifyError} />;
    }
  }
}

export default TwoFactorForm;


// WEBPACK FOOTER //
// ./src/components/DashboardPage/Account/TwoFactorForm/TwoFactorForm.js